/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Strong_Lion_PlanInputs */

const en_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel plan`)
};

const id_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batalkan paket`)
};

const ms_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batalkan pelan`)
};

const ca_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel·lar subscripció`)
};

const cs_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrušit plán`)
};

const da_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opsig abonnement`)
};

const de_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement kündigen`)
};

const et_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tühista plaan`)
};

const es_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar el plan`)
};

const fr_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler l’abonnement`)
};

const hr_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otkaži pretplatu`)
};

const it_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancella piano`)
};

const lv_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atcelt plānu`)
};

const lt_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atšaukti planą`)
};

const hu_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Előfizetés lemondása`)
};

const nl_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement opzeggen`)
};

const nb_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si opp abonnement`)
};

const pl_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anuluj usługę`)
};

const pt_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar plano`)
};

const ro_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anulează planul`)
};

const sk_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrušiť plán`)
};

const sl_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preklic naročnine`)
};

const fi_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peruuta tilaus`)
};

const sv_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avbryt plan`)
};

const vi_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hủy gói đăng ký`)
};

const tr_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planı iptal et`)
};

const el_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ακύρωση προγράμματος`)
};

const bg_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмяна на плана`)
};

const ru_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отменить план`)
};

const sr_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Откажи претплату`)
};

const uk_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скасувати план`)
};

const ka_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გეგმის გაუქმება`)
};

const hi_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्लान रद्द करें`)
};

const th_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยกเลิกแผน`)
};

const ko_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플랜 취소`)
};

const zh_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消套餐`)
};

const zh_tw_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消方案`)
};

const ja_bold_strong_lion_plan = /** @type {(inputs: Bold_Strong_Lion_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プランをキャンセル`)
};

/**
* | output |
* | --- |
* | "Cancel plan" |
*
* @param {Bold_Strong_Lion_PlanInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const bold_strong_lion_plan = /** @type {((inputs?: Bold_Strong_Lion_PlanInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Strong_Lion_PlanInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bold_strong_lion_plan(inputs)
	if (locale === "ms") return ms_bold_strong_lion_plan(inputs)
	if (locale === "ca") return ca_bold_strong_lion_plan(inputs)
	if (locale === "cs") return cs_bold_strong_lion_plan(inputs)
	if (locale === "da") return da_bold_strong_lion_plan(inputs)
	if (locale === "de") return de_bold_strong_lion_plan(inputs)
	if (locale === "et") return et_bold_strong_lion_plan(inputs)
	if (locale === "es") return es_bold_strong_lion_plan(inputs)
	if (locale === "fr") return fr_bold_strong_lion_plan(inputs)
	if (locale === "hr") return hr_bold_strong_lion_plan(inputs)
	if (locale === "it") return it_bold_strong_lion_plan(inputs)
	if (locale === "lv") return lv_bold_strong_lion_plan(inputs)
	if (locale === "lt") return lt_bold_strong_lion_plan(inputs)
	if (locale === "hu") return hu_bold_strong_lion_plan(inputs)
	if (locale === "nl") return nl_bold_strong_lion_plan(inputs)
	if (locale === "nb") return nb_bold_strong_lion_plan(inputs)
	if (locale === "pl") return pl_bold_strong_lion_plan(inputs)
	if (locale === "pt") return pt_bold_strong_lion_plan(inputs)
	if (locale === "ro") return ro_bold_strong_lion_plan(inputs)
	if (locale === "sk") return sk_bold_strong_lion_plan(inputs)
	if (locale === "sl") return sl_bold_strong_lion_plan(inputs)
	if (locale === "fi") return fi_bold_strong_lion_plan(inputs)
	if (locale === "sv") return sv_bold_strong_lion_plan(inputs)
	if (locale === "vi") return vi_bold_strong_lion_plan(inputs)
	if (locale === "tr") return tr_bold_strong_lion_plan(inputs)
	if (locale === "el") return el_bold_strong_lion_plan(inputs)
	if (locale === "bg") return bg_bold_strong_lion_plan(inputs)
	if (locale === "ru") return ru_bold_strong_lion_plan(inputs)
	if (locale === "sr") return sr_bold_strong_lion_plan(inputs)
	if (locale === "uk") return uk_bold_strong_lion_plan(inputs)
	if (locale === "ka") return ka_bold_strong_lion_plan(inputs)
	if (locale === "hi") return hi_bold_strong_lion_plan(inputs)
	if (locale === "th") return th_bold_strong_lion_plan(inputs)
	if (locale === "ko") return ko_bold_strong_lion_plan(inputs)
	if (locale === "zh") return zh_bold_strong_lion_plan(inputs)
	if (locale === "zh-tw") return zh_tw_bold_strong_lion_plan(inputs)
	if (locale === "ja") return ja_bold_strong_lion_plan(inputs)
	return en_bold_strong_lion_plan(inputs)
});